import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { SiteIpInfoComponent } from './site-ip-info.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [
        SiteIpInfoComponent
    ],
    providers: [],
    exports: []
})
export class SiteIpInfoModule {}
